import {
  ManagedByFilterProvider,
  PropertyTypeFilterProvider,
  RequiredFilterProvider,
} from '@github-ui/custom-properties-core/filter-providers'
import type {FilterProps, FilterProvider} from '@github-ui/filter'
import {Filter} from '@github-ui/filter'
import {OrgFilterProvider} from '@github-ui/filter/providers'
import {useMemo} from 'react'

interface Props extends Omit<FilterProps, 'providers' | 'id' | 'label'> {
  businessSlug?: string
}

export function DefinitionsFilter({filterValue, onChange, onSubmit, businessSlug, className, variant}: Props) {
  const providers = useMemo(() => {
    const providersList: FilterProvider[] = [
      new ManagedByFilterProvider(),
      new PropertyTypeFilterProvider(),
      new RequiredFilterProvider(),
    ]

    if (businessSlug) {
      providersList.push(
        new OrgFilterProvider({
          filterTypes: {valueless: false, exclusive: true},
          businessSlug,
        }),
      )
    }
    return providersList
  }, [businessSlug])

  return (
    <Filter
      id="properties-filter"
      label="Filter properties"
      className={className}
      providers={providers}
      filterValue={filterValue}
      onChange={onChange}
      onSubmit={onSubmit}
      variant={variant}
    />
  )
}

try{ DefinitionsFilter.displayName ||= 'DefinitionsFilter' } catch {}